import { INVOICE_ACCEPTED_FILE_TYPES, MAX_FILE_SIZE } from "../../Invoice/Invoice.config";

// Configure Development test file URLs for bypassing CORS
export const DEV_TEST_FILES = {
  pdf: `${process.env.PUBLIC_URL}/testfiles/test_invoice.pdf`,
  png: `${process.env.PUBLIC_URL}/testfiles/test_invoice.png`,
  docx: `${process.env.PUBLIC_URL}/testfiles/test_invoice.docx`,
};

/**
 * Validates an uploaded file against accepted types and size limits
 */
export const validateFile = (file: File): string[] => {
  const errors: string[] = [];

  // Check file type
  if (!INVOICE_ACCEPTED_FILE_TYPES.includes(file.type)) {
    errors.push("Please select a valid file type. Accepted: PDF, PNG, JPG, JPEG");
  }

  // Check file size
  if (file.size > MAX_FILE_SIZE) {
    errors.push("The selected file exceeds the maximum file size of 500MB");
  }

  return errors;
};

/**
 * Cleans file extension by removing leading dot if present
 */
export const cleanFileExtension = (rawFileType: string): string => {
  return rawFileType.startsWith(".") ? rawFileType.substring(1) : rawFileType;
};

/**
 * Gets development test file URL if available
 */
export const getDevTestFileUrl = (fileType: string): string | null => {
  if (
    process.env.NODE_ENV === "development" &&
    fileType &&
    DEV_TEST_FILES[fileType as keyof typeof DEV_TEST_FILES]
  ) {
    return DEV_TEST_FILES[fileType as keyof typeof DEV_TEST_FILES];
  }
  return null;
};
